import { PageId } from 'constants/pages'
import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'

const enum PageIdWoofz22V4L {
  SEX_V4L = PageId.SEX_V4L,
  DOG_AGE_V4L = PageId.DOG_AGE_V4L,
  DOG_BREED_V4L = PageId.DOG_BREED_V4L,
  URGE_V4L = PageId.URGE_V4L,
  COMMANDS_61_V4L = PageId.COMMANDS_61_V4L,
  COMMANDS_62_V4L = PageId.COMMANDS_62_V4L,
  COMMANDS_63_V4L = PageId.COMMANDS_63_V4L,
  URGE_2_V4L = PageId.URGE_2_V4L,
  POTTY_V4L = PageId.POTTY_V4L,
  BEHAVIOR_V4L = PageId.BEHAVIOR_V4L,
  TRAINING_V4L = PageId.TRAINING_V4L,
  PREPARE_FLOW_V4L = PageId.PREPARE_FLOW_V4L,
  DOG_STATISTICS_V4L = PageId.DOG_STATISTICS_V4L,
  EMAIL_V4L = PageId.EMAIL_V4L,
  NEWSLETTER_URGE_V4L = PageId.NEWSLETTER_URGE_V4L,
  LAST_CHANCE_OFFER_V4L = PageId.LAST_CHANCE_OFFER_V4L,
  SUBSCRIPTIONS_V4L_2 = PageId.SUBSCRIPTIONS_V4L_2,
  CHAT_UPSELL_V4L = PageId.CHAT_UPSELL_V4L,
  UPSELL_V4L = PageId.UPSELL_V4L,
  UPSELL_PITPAT_V4L = PageId.UPSELL_PITPAT_V4L,
  ACCOUNT_NOVE8 = PageId.ACCOUNT_NOVE8,
  DOWNLOAD_V4L = PageId.DOWNLOAD_V4L,
}

type TIdToPageMapWoofz22V4L = Record<PageIdWoofz22V4L, TPageMapValue>

export const ID_TO_PAGE_MAP_WOOFZ22V4L: TIdToPageMapWoofz22V4L = {
  sex_v4l: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz22_v4l/pages/questions/SexQuesiton').then(
        (m) => ({
          default: m.SexQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz22_v4l/pages/questions/SexQuesiton'),
  },
  dog_age_v4l: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz22_v4l/pages/questions/DogAgeQuestion').then(
        (m) => ({
          default: m.Component,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz22_v4l/pages/questions/DogAgeQuestion'),
  },
  dog_breed_v4l: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz22_v4l/pages/questions/dog-breed/DogBreedQuestion'
      ).then((m) => ({
        default: m.DogBreedQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz22_v4l/pages/questions/dog-breed/DogBreedQuestion'
      ),
  },
  urge_v4l: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz22_v4l/pages/questions/UrgePage').then(
        (m) => ({
          default: m.UrgePage,
        }),
      ),
    ),
    preload: () => import('nove8/cohorts/woofz22_v4l/pages/questions/UrgePage'),
  },
  commands_61_v4l: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz22_v4l/pages/questions/CommandsVariant61'
      ).then((m) => ({
        default: m.CommandsVariant61,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz22_v4l/pages/questions/CommandsVariant61'),
  },
  commands_62_v4l: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz22_v4l/pages/questions/CommandsVariant62'
      ).then((m) => ({
        default: m.CommandsVariant62,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz22_v4l/pages/questions/CommandsVariant62'),
  },
  commands_63_v4l: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz22_v4l/pages/questions/CommandsVariant63'
      ).then((m) => ({
        default: m.CommandsVariant63,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz22_v4l/pages/questions/CommandsVariant63'),
  },
  urge_2_v4l: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz22_v4l/pages/questions/UrgePageVariant2').then(
        (m) => ({
          default: m.UrgePageVariant2,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz22_v4l/pages/questions/UrgePageVariant2'),
  },
  potty_v4l: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz22_v4l/pages/questions/PottyQuestion').then(
        (m) => ({
          default: m.PottyQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz22_v4l/pages/questions/PottyQuestion'),
  },
  behavior_v4l: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz22_v4l/pages/questions/BehaviorQuestion').then(
        (m) => ({
          default: m.BehaviorQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz22_v4l/pages/questions/BehaviorQuestion'),
  },
  training_v4l: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz22_v4l/pages/questions/TrainingQuestion').then(
        (m) => ({
          default: m.TrainingQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz22_v4l/pages/questions/TrainingQuestion'),
  },
  prepare_flow_v4l: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz22_v4l/pages/questions/prepare-flow/PrepareFlow'
      ).then((m) => ({
        default: m.PrepareFlow,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz22_v4l/pages/questions/prepare-flow/PrepareFlow'
      ),
  },
  dog_statistics_v4l: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz22_v4l/pages/questions/dog-statistics/DogStatistics'
      ).then((m) => ({
        default: m.DogStatistics,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz22_v4l/pages/questions/dog-statistics/DogStatistics'
      ),
  },
  email_v4l: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz22_v4l/pages/email/Email22V4L').then((m) => ({
        default: m.Email22V4L,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz22_v4l/pages/email/Email22V4L'),
  },
  newsletter_urge_v4l: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz22_v4l/pages/email/components/NewsletterUrge'
      ).then((m) => ({
        default: m.NewsletterUrge,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz22_v4l/pages/email/components/NewsletterUrge'),
  },
  last_chance_offer_v4l: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz22_v4l/pages/last-chance-offer/LastChanceOfferPage'
      ).then((m) => ({
        default: m.LastChanceOfferPage,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz22_v4l/pages/last-chance-offer/LastChanceOfferPage'
      ),
  },
  subscriptions_v4l_2: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz22_v4l/pages/subscriptions/SubscriptionsPage'
      ).then((m) => ({
        default: m.SubscriptionsPage,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz22_v4l/pages/subscriptions/SubscriptionsPage'),
  },
  chat_upsell_v4l: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz22_v4l/pages/upsell/ChatUpsellNewFlow').then(
        (m) => ({
          default: m.ChatUpsellNewFlow,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz22_v4l/pages/upsell/ChatUpsellNewFlow'),
  },
  upsell_v4l: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz22_v4l/pages/upsell/Upsell').then((m) => ({
        default: m.Upsell,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz22_v4l/pages/upsell/Upsell'),
  },
  upsell_pitpat_v4l: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz22_v4l/pages/questions/DogAgeQuestion').then(
        (m) => ({
          default: m.Component,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz22_v4l/pages/questions/DogAgeQuestion'),
  },
  account_nove8: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz22_v4l/pages/questions/DogAgeQuestion').then(
        (m) => ({
          default: m.Component,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz22_v4l/pages/questions/DogAgeQuestion'),
  },
  download_v4l: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz22_v4l/pages/download-app/DownloadApp').then(
        (m) => ({
          default: m.DownloadApp,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz22_v4l/pages/download-app/DownloadApp'),
  },
}
